import { Injectable } from '@angular/core';
import { Data, NavigationExtras, Params, Router, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';

export interface RouterStateUrl {
    url: string;
    params: Params;
    queryParams: Params;
    datas: Data;
    extras: NavigationExtras | undefined;
}

@Injectable()
export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {

    constructor(private router: Router) { }

    serialize(routerState: RouterStateSnapshot): RouterStateUrl {
        let route = routerState.root;

        while (route.firstChild) {
            route = route.firstChild;
        }

        const {
            url,
            root: { queryParams },
        } = routerState;
        const { params } = route;
        const datas = route.data;
        const extras = this.router.getCurrentNavigation()?.extras;
        // Only return an object including the URL, params and query params
        // instead of the entire snapshot
        return { url, params, queryParams, datas, extras };
    }
}